module.exports = __webpack_public_path__ + "img/title_main_sp.38fd0601.svg";